import { useTranslations } from "next-intl";

import { Icon } from "@/components/icons/Icon";
import { twMerge } from "@/utils/twMerge";

export const SkipButton = ({
  onClick,
}: {
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
}) => {
  const t = useTranslations();

  return (
    <button
      onClick={onClick}
      type="button"
      className={twMerge(
        "flex items-center justify-end",
        "ml-auto mt-4 p-1",
        "text-gray-500 text-[18px] leading-[24px] tracking-tighter font-geist",
        "hover:opacity-60",
        "active:opacity-40",
      )}
    >
      <span className="mr-1.5">{t("createTeamDialog.skipButton")}</span>
      <Icon name="ArrowRight" className="w-[28px] h-[28px]" />
    </button>
  );
};
